(function (global) {
  'use strict';

  const chipAliases = {
    'ipad-air-5': 'M1',
    'ipad-pro-11-3rd-gen': 'M1',
    'ipad-pro-12-9-5th-gen': 'M1',
    'ipad-pro-11-4th-gen': 'M2',
    'ipad-pro-12-9-6th-gen': 'M2',
    'ipad-mini-a17-pro': '7th generation',
    'ipad-a16': '11th generation'
  };

  function normalise(value) {
    return value.toLowerCase()
      .replace(/\b(air|mini|pro)(\d)/g, '$1 $2')
      .replace(/\ba\s+(\d)/g, 'a$1')
      .replace(/(\d+)(st|nd|rd|th)\b/g, '$1')
      .replace(/\b(generation|gen|inch|inches)\b/g, ' ')
      .replace(/[^a-z0-9.]+/g, ' ').trim();
  }

  function matchesIpad(model, query) {
    const words = normalise(query).split(/\s+/).filter(Boolean);
    const searchable = normalise(`${model.name} ${model.year} ${chipAliases[model.id] || ''}`);
    const nameWords = searchable.split(/\s+/);
    return words.every(word => /^a\d+$/.test(word)
      ? nameWords.includes(word) || model.modelNumbers.some(number => number.toLowerCase().startsWith(word))
      : /^\d+(\.\d+)?$/.test(word) ? nameWords.includes(word) : searchable.includes(word));
  }

  // Text is added with textContent; model names are never interpolated into HTML.
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function icon(kind, size) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    const paths = {
      check: 'm5 12 4 4L19 6',
      cross: 'm6 6 12 12M18 6 6 18',
      search: 'M21 21l-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
      tablet: 'M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm6 16h2'
    };
    path.setAttribute('d', paths[kind]);
    svg.append(path);
    return svg;
  }

  function initChecker(root) {
    if (root.dataset.checkerInitialized) return;
    root.dataset.checkerInitialized = 'true';
    const input = root.querySelector('[data-model-search]');
    const list = root.querySelector('[data-model-list]');
    const popup = root.querySelector('[data-options]');
    const empty = root.querySelector('[data-model-empty]');
    const toggle = root.querySelector('[data-search-toggle]');
    const clear = root.querySelector('[data-search-clear]');
    const feedback = root.querySelector('[data-feedback]');
    const searchStatus = root.querySelector('[data-search-status]');
    const retry = root.querySelector('[data-search-retry]');
    let models = [];
    let filtered = [];
    let selected = null;
    let activeIndex = -1;
    let ready = false;
    let open = false;

    function setOpen(value) {
      open = Boolean(value && ready);
      popup.hidden = !open;
      input.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Hide iPad models' : 'Show iPad models');
      if (!open) setActive(-1);
    }

    function setActive(index) {
      activeIndex = index;
      Array.from(list.children).forEach((option, optionIndex) => {
        if (optionIndex === index) option.setAttribute('data-highlighted', '');
        else option.removeAttribute('data-highlighted');
      });
      const option = list.children[index];
      if (option && open) {
        input.setAttribute('aria-activedescendant', option.id);
        option.scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }

    function renderIdle(unrecognised) {
      const box = element('div', 'checker-idle');
      box.append(icon(unrecognised ? 'search' : 'tablet', unrecognised ? 27 : 31));
      box.append(element('h3', '', unrecognised ? 'We couldn’t identify that iPad.' : 'A little check. The right fit.'));
      box.append(element('p', '', unrecognised
        ? 'Check the Model Name or A-number in Settings and try again. An unrecognised model isn’t a compatibility result.'
        : 'Select your exact model to see whether it’s included in the planned Hovvi range.'));
      feedback.replaceChildren(box);
    }

    function renderResult(model) {
      const supported = model.designSupport;
      const box = element('div', `compatibility-result ${supported ? 'is-supported' : 'is-unsupported'}`);
      const heading = element('div', 'result-heading');
      const symbol = element('span', 'result-icon');
      symbol.append(icon(supported ? 'check' : 'cross', 21));
      const title = element('div');
      title.append(element('p', 'result-kicker', supported ? 'Planned model support' : 'Model not supported'));
      title.append(element('h3', '', supported ? 'Yes — this iPad is in our range.' : 'No — this iPad isn’t compatible.'));
      heading.append(symbol, title);
      const modelLine = element('p', 'result-model', model.name + ' ');
      modelLine.append(element('span', '', `(${model.year})`));
      box.append(heading, modelLine, element('p', '', supported
        ? 'A Hovvi mount is designed for this model. Final fit and charging compatibility are still being tested.'
        : 'Our current range is designed around selected iPad Air and iPad Pro models with the connector on the back.'));
      if (supported) {
        const availability = element('div', 'availability-line');
        availability.append(element('strong', '', 'Availability'), element('span', '', 'AUD $30 deposit · AUD $100 off at launch · Planned launch 30 October 2026'));
        const notify = element('button', 'button', 'Pre-order this mount for AUD $30');
        notify.type = 'button';
        notify.addEventListener('click', () => document.dispatchEvent(new CustomEvent('aerodock:interest', {
          detail: { intent: 'mount', model: model }
        })));
        box.append(availability, notify);
      } else {
        const bundle = element('a', 'text-link', 'Explore an iPad + mount bundle');
        bundle.href = '#bundles';
        box.append(bundle);
      }
      feedback.replaceChildren(box);
    }

    function choose(model) {
      selected = model;
      input.value = model.name;
      clear.hidden = false;
      renderOptions();
      renderResult(model);
      setOpen(false);
      searchStatus.textContent = `${model.name} selected.`;
    }

    function renderOptions() {
      filtered = models.filter(model => matchesIpad(model, input.value));
      const fragment = document.createDocumentFragment();
      filtered.forEach((model, index) => {
        const option = element('li', 'ipad-option');
        option.id = `${input.id}-option-${index}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', String(Boolean(selected && selected.id === model.id)));
        const label = element('span');
        label.append(element('strong', '', model.name), element('small', '', `${model.year} · ${model.modelNumbers.join(' / ')}`));
        option.append(label);
        option.addEventListener('mousedown', event => event.preventDefault());
        option.addEventListener('click', () => choose(model));
        option.addEventListener('pointermove', () => setActive(index));
        fragment.append(option);
      });
      list.replaceChildren(fragment);
      empty.hidden = filtered.length !== 0;
      setActive(-1);
      searchStatus.textContent = filtered.length === 0
        ? 'No matching models. Check the name or A-number.'
        : `${filtered.length} ${filtered.length === 1 ? 'model' : 'models'} found. Use the arrow keys to browse, then Enter to choose.`;
    }

    input.addEventListener('input', () => {
      selected = null;
      clear.hidden = input.value.length === 0;
      renderOptions();
      renderIdle(input.value.trim() !== '' && filtered.length === 0);
      setOpen(true);
    });
    input.addEventListener('focus', () => { if (ready) { renderOptions(); setOpen(true); } });
    input.addEventListener('click', () => setOpen(true));
    input.addEventListener('keydown', event => {
      if (!ready || event.isComposing) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        setOpen(true);
        if (filtered.length) {
          const next = event.key === 'ArrowDown'
            ? (activeIndex + 1) % filtered.length
            : activeIndex < 0 ? filtered.length - 1 : (activeIndex - 1 + filtered.length) % filtered.length;
          setActive(next);
        }
      } else if (event.key === 'Enter' && open && activeIndex >= 0) {
        event.preventDefault();
        choose(filtered[activeIndex]);
      } else if (event.key === 'Escape' && open) {
        event.preventDefault();
        setOpen(false);
      } else if (event.key === 'Tab') setOpen(false);
    });
    toggle.addEventListener('click', () => {
      const wasOpen = open;
      input.focus();
      setOpen(!wasOpen);
    });
    clear.addEventListener('click', () => {
      selected = null;
      input.value = '';
      clear.hidden = true;
      renderOptions();
      renderIdle(false);
      input.focus();
      setOpen(true);
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) setOpen(false); });
    root.addEventListener('focusout', () => {
      setTimeout(() => { if (!root.contains(document.activeElement)) setOpen(false); }, 0);
    });

    async function loadModels() {
      ready = false;
      input.disabled = true;
      toggle.disabled = true;
      retry.hidden = true;
      searchStatus.textContent = 'Loading iPad models…';
      root.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        if (!root.dataset.modelsUrl) throw new Error('Missing model catalogue URL');
        const response = await fetch(root.dataset.modelsUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('Model catalogue unavailable');
        const catalog = await response.json();
        if (!Array.isArray(catalog.models) || !catalog.models.length || catalog.models.some(model =>
          typeof model.id !== 'string' || typeof model.name !== 'string' || typeof model.year !== 'number' ||
          typeof model.designSupport !== 'boolean' || !Array.isArray(model.modelNumbers) ||
          model.modelNumbers.some(number => typeof number !== 'string'))) throw new Error('Invalid model catalogue');
        models = catalog.models;
        ready = true;
        input.disabled = false;
        toggle.disabled = false;
        renderOptions();
        searchStatus.textContent = 'Model search ready.';
      } catch (error) {
        setOpen(false);
        searchStatus.textContent = 'We couldn’t load the iPad model list. Check your connection and try again.';
        retry.hidden = false;
      } finally {
        clearTimeout(timeout);
        root.removeAttribute('aria-busy');
      }
    }
    retry.addEventListener('click', loadModels);
    loadModels();
  }

  function init(scope) {
    scope.querySelectorAll('[data-aerodock-compatibility]').forEach(initChecker);
  }

  const api = { normalise: normalise, matchesIpad: matchesIpad, init: init };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.HovviCompatibility = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})(typeof window !== 'undefined' ? window : globalThis);
